import type { Education } from '../types'

interface EducationCardProps {
  education: Education
}

export function EducationCard({ education }: EducationCardProps) {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow duration-200">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-2">
        <h3 className="text-lg font-semibold text-slate-900 dark:text-white">
          {education.degree}
        </h3>
        <span className="text-sm text-slate-500 dark:text-slate-400">
          {education.startDate} - {education.endDate}
        </span>
      </div>

      {/* Field of study */}
      <p className="text-orange-500 dark:text-orange-400 font-medium mb-2">
        {education.field}
      </p>

      {/* Institution and location */}
      <p className="text-slate-600 dark:text-slate-400 mb-2">
        {education.institution}
        <span className="text-slate-400 dark:text-slate-500"> &middot; {education.location}</span>
      </p>

      {/* Description */}
      {education.description && (
        <p className="text-slate-600 dark:text-slate-400 text-sm">{education.description}</p>
      )}
    </div>
  )
}
